import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '../../Link';
import Image from '../../Image';

import './Logo.module.scss';

class Logo extends React.PureComponent {
  render() {
    const { isMobile: mobile, imageUrl, imageLink, imageScale, align, defaultImage } = this.props;

    const scale = imageScale / 100;
    const style = { transform: `scale(${scale}, ${scale})` };

    const styleName = classNames('link', align, {
      mobile,
    });

    return (
      <Link styleName={styleName} href={imageLink}>
        {imageUrl ? <Image alt="Company logo" styleName="logo-image" style={style} src={imageUrl} /> : defaultImage}
      </Link>
    );
  }
}

Logo.propTypes = {
  isMobile: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'right']),
  imageUrl: PropTypes.string,
  imageLink: PropTypes.string,
  imageScale: PropTypes.number,
  defaultImage: PropTypes.node,
};

export default Logo;
